export default __webpack_public_path__ + "static/media/outline.1a8f3935.png";